import React from "react"
import PropTypes from "prop-types"

import * as am4core from '@amcharts/amcharts4/core';
import { XYChart } from '@amcharts/amcharts4/.internal/charts/types/XYChart';
import { ValueAxis } from '@amcharts/amcharts4/.internal/charts/axes/ValueAxis';
import { DateAxis } from '@amcharts/amcharts4/.internal/charts/axes/DateAxis';
import { LineSeries } from '@amcharts/amcharts4/.internal/charts/series/LineSeries';
import { XYCursor } from '@amcharts/amcharts4/.internal/charts/cursors/XYCursor';
import am4themes_animated from '@amcharts/amcharts4/themes/animated';

import { color } from '@amcharts/amcharts4/.internal/core/utils/Color';

import { PieChart3D } from '@amcharts/amcharts4/.internal/charts/types/PieChart3D';

import { Legend } from '@amcharts/amcharts4/.internal/charts/Legend';
import './index.css'
import ColumnCylinder from "../CylinderColumnChart/ColumnCylinder";

const DEFAULT_COLORS = [
  color('#1ABC9C'),
  color('#FEBC77'),
  color('#2980B9'),
  color('#F1C40F'),
  color('#FF7043'),
  color('#9B59B6'),
  color('#27AE60'),
  color('#E74C3C'),
  color('#2ECC71'),
  color('#8DB7D7'),
  color('#E67E22'),
  color('#8E44AD'),
  color('#16A085'),
  color('#6D4C41'),
  color('#F39C12'),
  color('#D35400'),
  color('#3498DB'),
  color('#AD1457'),
  color('#66BB6A'),
  color('#ACE1AF'),
  color('#F7E7CE'),
  color('#FFB7C5'),
  color('#7B3F00'),
];


am4core.useTheme(am4themes_animated);

class SmallLineChart extends React.Component {
  constructor(props) {
    super(props)
  }

  componentDidMount() {
    this.chart = am4core.create(this.props.chartId, XYChart);
    this.chart.cursor = new XYCursor();
    this.chart.cursor.lineY.disabled = true;

    this.initColors();
    this.chart.colors.reuse = true;

    this.dateAxis = this.chart.xAxes.push(new DateAxis());
    this.dateAxis.renderer.minGridDistance = 10;
    this.dateAxis.renderer.grid.template.disabled = true;
    this.dateAxis.renderer.labels.template.disabled = true;
    // this.dateAxis.renderer.baseGrid.disabled = true;
    // this.dateAxis.renderer.grid.template.location = 0.5;
    // this.dateAxis.startLocation = 0.5;
    // this.dateAxis.endLocation = 0.5;

    const dateTemplate = this.dateAxis.renderer.labels.template;
    dateTemplate.fontSize = 14;
    dateTemplate.fill = color('#CEDBDC');


    this.valueAxis = this.chart.yAxes.push(new ValueAxis());
    this.valueAxis.renderer.grid.template.disabled = true;
    this.valueAxis.renderer.labels.template.disabled = true;
    // this.valueAxis.renderer.baseGrid.disabled = true;

    // this.chart.cursor.xAxis = this.categoryAxis;

    this.createSeries();
    // this.createSeries2();
    // this.createSeries3();
    this.updateChartsData();

  }

  componentWillUnmount() {
    if (this.chart) {
      this.chart.dispose();
    }
  }

  componentDidUpdate(prevProps) {

  }

  initColors = () => {
    this.chart.colors.list = [color(`${this.props.color}`)];
  };

  createSeries = () => {
    this.series = this.chart.series.push(new LineSeries());
    this.series.dataFields.valueY = "value1";
    this.series.dataFields.dateX = "date";
    this.series.strokeWidth = 2;
    this.series.strokeWidth = 3;
    this.series.tensionX = 0.8;

    let filter = this.series.filters.push(new am4core.DropShadowFilter());
    filter.color = am4core.color("#1ABC9C");
    filter.dx = 10;
    filter.dy = 0;
    filter.blur = 10;
    filter.opacity = 0.5;
  }

  updateChartsData = () => {

    const currentDate = new Date();

    this.chart.data = this.props.dataset.map((item, index) => {
      return {
        date: new Date(currentDate.setDate(currentDate.getDate() + (index + 1))),
        value1: item
      }
    });
  }

  render() {
    return (
      <div style={{ width: '99%'}}>
        <div id={this.props.chartId} style={{ width: '200px', height: "125px" }}></div>
      </div>
    )
  }
}

SmallLineChart.propTypes = {
  dataset: PropTypes.array,
  color: PropTypes.array,
  chartId: PropTypes.string
}

export default SmallLineChart
